import { render } from "./thana-settings.vue?vue&type=template&id=bc2b8efc"
import script from "./thana-settings.vue?vue&type=script&lang=js"
export * from "./thana-settings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__